"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EConfirmPhoneStatus = void 0;
let EConfirmPhoneStatus = exports.EConfirmPhoneStatus = /*#__PURE__*/function (EConfirmPhoneStatus) {
  EConfirmPhoneStatus["Initial"] = "initial";
  EConfirmPhoneStatus["Loading"] = "loading";
  EConfirmPhoneStatus["Succeed"] = "succeed";
  EConfirmPhoneStatus["Failed"] = "failed";
  return EConfirmPhoneStatus;
}({});